import { Icon } from '@chakra-ui/react';

export const CustomScansIcon = (props) => (
  <Icon viewBox="0 0 30 30" width="30px" height="30px" {...props} mt={1}>
    <path
      className="multicolorElToDark darkBgElToBrand"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H8V2H2V8H0V1ZM22 2H16V0H23C23.2652 0 23.5196 0.105357 23.7071 0.292893C23.8946 0.48043 24 0.734784 24 1V8H22V2ZM24 13H0V11H24V13ZM2 22V16H0V23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24H8V22H2ZM22 22V16H24V23C24 23.2652 23.8946 23.5196 23.7071 23.7071C23.5196 23.8946 23.2652 24 23 24H16V22H22Z"
      fill="#FFFFFF"
    />
  </Icon>
);
